import { Box, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={3}>
		<Text semiBold text="normal" />
		<Text semiBold text="font size" />
		<Text semiBold text="line height" />
		<Box border={STANDARD_BORDER_STYLE}>
			<Text text="The quick brown fox jumps over the lazy dog!" />
		</Box>
		<Box border={STANDARD_BORDER_STYLE}>
			<Text size={18} text="The quick brown fox jumps over the lazy dog!" />
		</Box>
		<Box border={STANDARD_BORDER_STYLE}>
			<Text lineHeight={34} text="The quick brown fox jumps over the lazy dog!" />
		</Box>
	</CssColumnGrid>
);
